import { formatPhoneNumber } from 'react-phone-number-input'

function MappingExampleRows({ selected, exampleRows, isPhone, enterManually }) {
    if (!exampleRows || !selected) return null

    const displayValue = (row) =>
        enterManually && isPhone
            ? formatPhoneNumber(selected)
            : enterManually
            ? selected
            : row[selected]

    return (
        <div className="space-y-1 text-[12px] leading-[1.4] text-gray-500">
            {exampleRows.map((row, index) => (
                <div
                    key={index}
                    className="overflow-hidden text-ellipsis whitespace-nowrap">
                    {displayValue(row)}
                </div>
            ))}
        </div>
    )
}

export default MappingExampleRows
